<template>
  <div v-if="isReady">
    <Panel :padding="[22, 24]">
      <div class="question-desc">
        <div class="question-desc-text">{{ currItem.question_description_obj[computedLang] }}</div>
        <div class="language-select-con" v-if="currItem.screen_text_trans">
          <!-- <p class="title">{{ $t('edit_message_language') }}</p> -->
          <el-select
            v-model="translationLanguage"
            size="small"
            @change="changeLanguage"
            class="language-select"
          >
            <el-option
              v-for="item in languageList"
              :key="item.value"
              :label="item.title"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <slot></slot>
      </div>
      <div class="panel-content">
        <div class="panel-article" v-if="currItem.screen_text">
          <div v-for="(screenText, index) in currItem.screen_text" :key="index + screenText.type">
            <img
              style="width: 500px"
              v-if="screenText.type == 'image'"
              :src="baseUrl + screenText.content + '?width=300'"
              alt=""
            />
            <p v-else-if="screenText.type == 'text'">{{ screenText.content }}</p>
          </div>
        </div>
        <div v-if="currItem.screen_text_trans" class="question-stem">
          <span class="question-index">{{ currItem.index }}.</span>
          <div v-html="translationStem"></div>
        </div>

        <div class="answer_result">
          <div class="answer_result-title">{{ $t('mark_answer') }}:</div>
          <div v-if="currItem.useAnswer">
            <p class="title">{{ currItem.useAnswer }}</p>
          </div>
          <strong v-else>{{ $t('hsk_homework_no_answer') }}</strong>
          <div class="limit">{{ wordLength || 0 }} / {{ currItem.answer_limit }}</div>
        </div>
        <div class="reference_answer" v-if="currItem.evaluate">
          <div>{{ $t('hsk_reference_answer') }}</div>
          <p v-for="(txt, key) in currItem.evaluate.standard_answer" :key="key + currItem.index">
            {{ txt }}
          </p>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
import { getAllWordsLength } from '@/utils/utils'
import { getLanguageSelectList, getScreenTextByLanguage } from '@/utils/hskTool'
export default {
  name: 'CommonWritePuResult',
  props: {
    currItem: {
      type: Object,
      default: () => {},
    },
    baseUrl: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      inputTitle: '',
      inputText: '', // 统计所有文本字数
      inputTextResult: [],
      translationLanguage: '',
      languageList: [],
      translationStem: '',
    }
  },
  watch: {
    currItem: {
      handler(val) {
        if (val.screen_text_trans) {
          // 如果是翻译，需要初始化多语言列表，展示对应的多语言题干
          this.languageList = getLanguageSelectList(val.screen_text_trans)
          console.log(this.languageList, 1000000000000000000000000000000000000)
          this.translationLanguage =
            sessionStorage.getItem('translationLanguage') || this.languageList[0].value
          this.translationStem = getScreenTextByLanguage(
            val.screen_text_trans,
            this.translationLanguage
          )
        }
      },
      immediate: true,
    },
  },
  methods: {
    changeLanguage() {
      this.translationStem = getScreenTextByLanguage(
        this.currItem.screen_text_trans,
        this.translationLanguage
      )
      sessionStorage.setItem('translationLanguage', this.translationLanguage)
    },
  },
  computed: {
    isReady() {
      return JSON.stringify(this.currItem) !== '{}'
    },
    wordLength() {
      console.log(this.inputText)
      return getAllWordsLength(this.currItem.useAnswer)
    },
    computedLang() {
      return localStorage.getItem('language') || 'zh'
    },
    // computedText() {
    //   return this.currItem?.screen_text.slice(1, this.currItem?.screen_text.length)
    // },
    analysisText() {
      return this.currItem.evaluate.standard_answer[0].split('\n')
    },
  },
}
</script>

<style lang="scss" scoped>
.question-desc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding-top: 10px;
  .question-desc-text {
    max-width: 980px;
  }
  .language-select-con {
    position: absolute;
    top: 6px;
    right: 180px;
    width: 100px;
  }
}
.question-stem {
  margin-bottom: 20px;
  margin-top: 20px;
  display: flex;
  .question-index {
    color: #b5b5be;
    margin-right: 8px;
  }
}
.panel-content {
  margin-left: 32px;
  margin-top: 12px;
  .panel-article {
    p {
      text-indent: 2em;
      font-size: 14px;
      font-weight: 400;
      color: #393d46;
      line-height: 25px;
    }
  }
  .answer_result {
    &-title {
      color: #faae56;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      margin-top: 24px;
      margin-bottom: 8px;
    }
    p {
      font-weight: 600;
      font-size: 14px;
      color: #2c2f46;
      text-indent: 2em;
      line-height: 25px;
      word-break: break-word;
    }
    strong {
      font-weight: 600;
    }
    .limit {
      font-weight: 600;
      font-size: 14px;
      color: #2c2f46;
      margin-top: 10px;
      text-align: right;
    }
  }
  .reference_answer {
    margin-top: 24px;
    div {
      color: #faae56;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      margin-top: 24px;
      margin-bottom: 8px;
    }
    p {
      font-size: 14px;
      color: #545961;
      line-height: 25px;
      text-indent: 2em;
    }
  }
}
</style>
